import { create } from "zustand";

/** Console shell UI state only (sidebar) — server data stays in TanStack Query. */
interface ConsoleShellState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export const useConsoleShellStore = create<ConsoleShellState>((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
}));
